"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const customLockedColumn = (arg) => {
    const lockedCell = ({ dataIndex, dataItem, field, style }) => {
        const itemData = dataItem;
        return ((0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 1, role: 'gridcell', "aria-selected": 'false', "aria-colindex": dataIndex, "data-grid-col-index": dataIndex, className: 'k-grid-content-sticky', id: `m_grid_cell_${field}_${dataIndex}`, style: Object.assign(Object.assign({}, style), arg.customStyle) }, { children: arg.value ? arg.value : field && itemData[field].toString() })));
    };
    return lockedCell;
};
exports.default = customLockedColumn;
